// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconQuestion = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M12 15c-.41 0-.75-.34-.75-.75v-1.01c0-.95.6-1.8 1.5-2.12 1.08-.38 1.7-1.51 1.44-2.63-.26-1.11-1.31-1.87-2.45-1.73-1.14.13-2 1.09-2 2.24a.749.749 0 11-1.5 0 3.754 3.754 0 017.41-.85c.43 1.86-.6 3.74-2.4 4.38-.3.11-.5.39-.5.71v1.01c0 .42-.33.75-.75.75zm1.13 2.63c0-.62-.5-1.12-1.12-1.12-.62 0-1.12.5-1.12 1.12 0 .62.5 1.12 1.12 1.12.62 0 1.12-.5 1.12-1.12zM24 12c0-6.62-5.38-12-12-12S0 5.38 0 12s5.38 12 12 12 12-5.38 12-12zm-1.5 0c0 5.79-4.71 10.5-10.5 10.5S1.5 17.79 1.5 12 6.21 1.5 12 1.5 22.5 6.21 22.5 12z"
      fill="currentColor"
    />
  );
export default SvgIconQuestion;
